import { Badge, Group, Loader, Stack, Text, Timeline } from '@mantine/core'
import { useQuery } from '@tanstack/react-query'
import type { AsientoHistorial } from '@serkat/shared'
import { api } from '../../api/cliente'
import { COLOR_ESTADO } from '../../tema/tema'

const FMT = new Intl.DateTimeFormat('es-PE', { dateStyle: 'medium', timeStyle: 'short' })

/**
 * La cadena de auditoría de un documento. Cada asiento identifica a quién lo
 * movió y por qué; la base no acepta cambios de estado sin él.
 */
export function HistorialEstados({ documentoId }: { documentoId: string }) {
  const { data, isPending } = useQuery({
    queryKey: ['historial', documentoId],
    queryFn: () => api.get<AsientoHistorial[]>(`/documentos/${documentoId}/historial`),
  })

  if (isPending) return <Loader size="sm" />
  if (!data || data.length === 0) return <Text c="dimmed" size="sm">Sin movimientos.</Text>

  return (
    <Timeline active={data.length - 1} bulletSize={16} lineWidth={2}>
      {data.map((a) => (
        <Timeline.Item
          key={a.id}
          title={
            <Group gap={8}>
              {a.estadoAnterior && (
                <>
                  <Badge size="xs" variant="light" color={COLOR_ESTADO[a.estadoAnterior]}>
                    {a.estadoAnterior}
                  </Badge>
                  <Text size="xs" c="dimmed">→</Text>
                </>
              )}
              <Badge size="xs" variant="light" color={COLOR_ESTADO[a.estadoNuevo]}>
                {a.estadoNuevo}
              </Badge>
            </Group>
          }
        >
          <Stack gap={2}>
            <Text size="xs" c="dimmed">
              {a.usuario}{a.cargo ? ` · ${a.cargo}` : ''} — {FMT.format(new Date(a.fecha))}
            </Text>
            {a.motivo && <Text size="sm">{a.motivo}</Text>}
          </Stack>
        </Timeline.Item>
      ))}
    </Timeline>
  )
}
